import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	virtualServiceAgent: {
		id: 'spa-apps-sidebar-servicedesk.common.virtual-agent.virtual-service-agent',
		defaultMessage: 'Virtual service agent',
		description: 'Settings navigation section title for a service project',
	},
	virtualAgentLozengeText: {
		id: 'spa-apps-sidebar-servicedesk.common.virtual-agent.virtual-agent-lozenge-text',
		defaultMessage: 'New',
		description: 'Lozenge text next to navigation menu item for service project',
	},
});
